var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-layout',{attrs:{"siderPosition":"right","search":{ action: _vm.search, placeholder: 'cari id order ...' }}},[_c('template',{slot:"content"},[_c('order-table',{attrs:{"dataSource":_vm.items.data,"get-data-function":_vm.getItems,"pagination":_vm.pagination,"change-page":_vm.changePage,"change-size-page":_vm.changeSizePage}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }